import { render, staticRenderFns } from "./VentasPorMes.vue?vue&type=template&id=104f5a4d&scoped=true"
import script from "./VentasPorMes.vue?vue&type=script&lang=js"
export * from "./VentasPorMes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104f5a4d",
  null
  
)

export default component.exports